<template>
  <v-btn
    :disabled="isDisabled"
    :loading="isLoading"
    :outlined="!isColorBranche"
    block
    class="btn-secondaire mr-4 action"
    color="primary"
    elevation="0"
    rounded
    @click="onClick"
  >
    <v-icon v-if="icon">
      {{ icon }}
    </v-icon>
    {{ libelleBtn }}
  </v-btn>
</template>

<script>

export default {
  name: 'BaseButton',
  props: {
    libelleBtn: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    /**
     * true = bouton vert - texte blanc
     * false = bouton blanc - texte vert
     */
    isColorBranche: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
  },

  methods: {
    onClick () {
      this.$emit('click')
    }
  }
}
</script>
